import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../api";
import { AttendanceLocalService } from "../../../../@types/attendance-local-service";
import { AxiosError } from "axios";

export function useAttendanceLocalServiceDelete(id: AttendanceLocalService['id']) {
  const queryClient = useQueryClient();
  const token = localStorage.getItem("gov_access_token_sso");

  const mutation = useMutation({
    mutationKey: ["attendance-local", "service", "delete", id],
    mutationFn: async () => {
      const response = await apisiseci.delete<{ detail: string }>(
        `/cms/servicos_unidades/${id}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
    onSuccess: async () => {
      toast.success("Serviço excluído com sucesso!");

      await queryClient.invalidateQueries({
        queryKey: ['attendance-local', 'service', 'list'],
      });

      await queryClient.invalidateQueries({
        queryKey: ['service-available', 'list'],
      });
    },
    onError: (error: AxiosError<{ detail: string }>) => {
      toast.error(
        error.response.data.detail || "Algo deu errado, tente novamente!"
      );
      console.log(error);
    },
  });

  return mutation;
}
